/*
 * Blog header search, modelled on the GlobeVM blog search.
 *
 * Clicking the search icon turns the whole blog header into a search bar
 * (× closes it). Typing two or more characters searches published blog posts
 * through Shopify's predictive search and lists them in a full-width panel
 * under the header: picture, category, title, author and date.
 * Escape or a click outside also closes it; Enter opens the first result.
 * While results show, the rest of the page is dimmed, as on GlobeVM.
 * Styles: assets/lum-blog-search.css.
 */
(function () {
  var MIN_CHARS = 2;
  var DELAY = 250;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sized(url, width) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function blogHandle(url) {
    var m = /\/blogs\/([^/?#]+)/.exec(url || '');
    return m ? m[1] : '';
  }

  function formatDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    // same format as the blog cards: 28 September 2026
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function init(section) {
    if (!section || section.dataset.lumBlogSearch) return;
    var header = section.querySelector('.header-blog');
    var inner = section.querySelector('.header-blog__inner');
    var toggle = section.querySelector('[data-blog-search-toggle]');
    var template = section.querySelector('[data-blog-search-template]');
    if (!header || !inner || !toggle || !template) return;
    section.dataset.lumBlogSearch = '1';

    var texts = section.querySelector('[data-blog-search-text]') || document.createElement('span');
    var label = {
      results: texts.dataset.results || 'Result For',
      searching: texts.dataset.searching || 'Searching...',
      empty: texts.dataset.empty || 'No articles found',
      by: texts.dataset.by || 'By'
    };
    var names = {};
    try {
      names = JSON.parse(section.querySelector('[data-blog-search-map]').textContent);
    } catch (e) {
      names = {};
    }

    var bar = null;
    var panel = null;
    var backdrop = null;
    var input = null;
    var heading = null;
    var list = null;
    var timer = null;
    var request = null;

    function cancel() {
      clearTimeout(timer);
      if (request) request.abort();
      request = null;
    }

    function status(text) {
      list.innerHTML = '';
      list.appendChild(el('p', 'lum-blog-search__status', text));
    }

    function render(articles, query) {
      heading.textContent = label.results + " '" + query + "'";
      list.innerHTML = '';
      if (!articles.length) {
        status(label.empty);
        return;
      }
      articles.forEach(function (a) {
        var link = el('a', 'lum-blog-search__result');
        link.href = a.url;

        var thumb = el('span', 'lum-blog-search__thumb');
        var src = typeof a.image === 'string' ? a.image : (a.image && a.image.url);
        if (src) {
          var img = el('img');
          img.src = sized(src, 240);
          img.alt = '';
          img.width = 96;
          img.height = 64;
          img.loading = 'lazy';
          thumb.appendChild(img);
        }
        // without a picture the thumbnail stays an empty grey tile

        var body = el('span', 'lum-blog-search__body');
        var handle = blogHandle(a.url);
        body.appendChild(el('span', 'lum-blog-search__category', names[handle] || handle.replace(/-/g, ' ')));
        body.appendChild(el('span', 'lum-blog-search__title', a.title));
        var meta = el('span', 'lum-blog-search__meta');
        if (a.author) meta.appendChild(el('span', '', label.by + ' ' + a.author));
        var date = formatDate(a.published_at);
        if (date) meta.appendChild(el('span', '', date));
        if (meta.childNodes.length) body.appendChild(meta);

        link.appendChild(thumb);
        link.appendChild(body);
        list.appendChild(link);
      });
    }

    function search(query) {
      cancel();
      if (query.length < MIN_CHARS) {
        panel.hidden = true;
        backdrop.hidden = true;
        return;
      }
      panel.hidden = false;
      backdrop.hidden = false;
      heading.textContent = label.results + " '" + query + "'";
      status(label.searching);
      timer = setTimeout(function () {
        request = new AbortController();
        var url = shopRoot() + 'search/suggest.json' +
          '?q=' + encodeURIComponent(query) +
          '&resources[type]=article' +
          '&resources[limit]=10' +
          '&resources[options][fields]=title,body,author,tag';
        fetch(url, { signal: request.signal, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            render((data.resources && data.resources.results && data.resources.results.articles) || [], query);
          })
          .catch(function (e) {
            if (e.name !== 'AbortError') render([], query);
          });
      }, DELAY);
    }

    function onOutside(e) {
      if (bar && !header.contains(e.target)) close(false);
    }

    function onKey(e) {
      if (e.key === 'Escape') close(true);
    }

    function open() {
      if (bar) return;
      var parts = template.content.cloneNode(true);
      bar = parts.querySelector('[data-blog-search]');
      panel = parts.querySelector('[data-blog-search-panel]');
      backdrop = parts.querySelector('[data-blog-search-backdrop]');
      inner.insertBefore(bar, inner.firstChild);
      header.appendChild(panel);
      document.body.appendChild(backdrop);
      header.classList.add('header-blog--searching');

      input = bar.querySelector('[data-blog-search-input]');
      heading = panel.querySelector('[data-blog-search-heading]');
      list = panel.querySelector('[data-blog-search-results]');

      input.addEventListener('input', function () {
        search(input.value.trim());
      });
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var first = list.querySelector('a.lum-blog-search__result');
        if (first) window.location.href = first.href;
      });
      bar.querySelector('[data-blog-search-close]').addEventListener('click', function () {
        close(true);
      });

      document.addEventListener('click', onOutside);
      document.addEventListener('keydown', onKey);
      toggle.setAttribute('aria-expanded', 'true');
      input.focus();
    }

    function close(returnFocus) {
      if (!bar) return;
      cancel();
      document.removeEventListener('click', onOutside);
      document.removeEventListener('keydown', onKey);
      bar.remove();
      panel.remove();
      backdrop.remove();
      bar = null;
      panel = null;
      backdrop = null;
      header.classList.remove('header-blog--searching');
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      open();
    });
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.header-blog').forEach(function (header) {
      init(header.parentElement);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // the Theme Editor re-renders a section after a setting changes
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
